export default "__VITE_ASSET__DTKM6837__"